import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mapAltFilled"
const MapAltFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.25 9.375C20.15 9.375 22.5 11.452 22.5 14.6Q22.5 14.736 22.49 14.873 22.491 14.897 22.488 14.92 22.481 15.053 22.466 15.186L22.46 15.223Q22.451 15.302 22.44 15.382 22.422 15.499 22.4 15.616L22.379 15.731Q22.356 15.836 22.33 15.941 22.315 16.013 22.296 16.085 22.274 16.169 22.25 16.254 22.152 16.589 22.026 16.92 22.003 16.984 21.98 17.046L21.9 17.236 21.843 17.368Q21.798 17.47 21.75 17.574L21.71 17.658C20.408 20.379 17.89 22.675 17.25 22.675 16.645 22.675 14.369 20.633 13.02 18.116L12.967 18.015Q12.897 17.88 12.83 17.745L12.784 17.648Q12.72 17.514 12.66 17.378L12.61 17.263Q12.557 17.14 12.508 17.017L12.453 16.873Q12.408 16.753 12.368 16.63 12.345 16.568 12.325 16.505 12.285 16.377 12.248 16.25L12.202 16.082 12.182 16.008Q12.145 15.852 12.113 15.698L12.107 15.66Q12.076 15.503 12.053 15.347L12.04 15.236 12.03 15.159 12.018 15.027 12.013 14.97 12.006 14.835Q12.006 14.812 12.003 14.791L12 14.601Q12 14.468 12.006 14.34L12.009 14.26Q12.025 14.008 12.058 13.765L12.065 13.72Q12.1 13.468 12.16 13.229L12.173 13.177Q12.196 13.088 12.22 13L12.248 12.91Q12.276 12.82 12.307 12.732 12.323 12.687 12.34 12.643L12.393 12.503 12.428 12.42Q12.466 12.334 12.505 12.25L12.538 12.18 12.604 12.049 12.661 11.947Q12.698 11.88 12.736 11.815L12.79 11.728 12.854 11.628Q12.966 11.46 13.089 11.303L13.137 11.245Q13.27 11.08 13.417 10.928L13.476 10.869Q13.628 10.718 13.793 10.581L13.812 10.564Q14.185 10.256 14.615 10.024 14.62 10.02 14.625 10.017C15.085 9.77 15.59 9.588 16.125 9.483L16.143 9.48Q16.242 9.46 16.342 9.446 16.38 9.439 16.419 9.434 16.494 9.423 16.569 9.415L16.702 9.4 16.832 9.39 16.973 9.38Q17.11 9.376 17.25 9.376M17.25 12.75C16.422 12.75 15.75 13.422 15.75 14.25S16.422 15.75 17.25 15.75 18.75 15.078 18.75 14.25 18.078 12.75 17.25 12.75"
            clipRule="evenodd"
          />
          <path d="M7.875 20.446 3.344 21.513C2.402 21.735 1.5 21.02 1.5 20.053V4.973C1.5 4.328 1.913 3.757 2.521 3.552 4.528 2.872 5.841 2.4 7.875 1.712zM14.625 2.815V8.774C12.428 9.703 10.875 11.81 10.875 14.6 10.875 16.88 12.157 19.147 13.41 20.754Q13.7 21.124 13.995 21.46L9.375 20.435V1.648zM20.657 1.737C21.598 1.515 22.5 2.23 22.5 3.197V10.882C21.343 9.23 19.409 8.25 17.25 8.25Q16.675 8.251 16.125 8.342V2.802z" />
        </svg>
      }
    </span>
  )
}
export default MapAltFilledIcon
